import { render, staticRenderFns } from "./ShowactadressList.vue?vue&type=template&id=b8a85d2a&"
import script from "./ShowactadressList.vue?vue&type=script&lang=js&"
export * from "./ShowactadressList.vue?vue&type=script&lang=js&"
import style0 from "./ShowactadressList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports